import Vuex from '@front/common/vuex'

export default function useConfirmationModal() {
  const store = Vuex.useStore()

  async function confirm() {
    store.dispatch('confirmation/openConfirmation')
    store.dispatch('modal/open', 'confirmation-modal')

    try {
      await store.state.confirmation.confirmPromise.promise

      store.dispatch('confirmation/closeConfirmation')
      store.dispatch('modal/close', 'confirmation-modal')

      return Promise.resolve()
    } catch {
      store.dispatch('confirmation/closeConfirmation')
      store.dispatch('modal/close', 'confirmation-modal')

      return Promise.reject()
    }
  }

  return { confirm }
}
